import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';
import COMPANY from '../legal/company';

const PAGES = [
  { to: '/terms', label: 'Terms of Service' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/refund-policy', label: 'Refund & Cancellation' },
  { to: '/security', label: 'Security & Data' }
];

/** Shell for the legal pages: title, last updated, the page's sections, and links to the other legal pages. */
function LegalPage({ title, intro, children }) {
  useEffect(() => {
    document.title = `${title} - ${COMPANY.brand}`;
    window.scrollTo(0, 0);
    return () => { document.title = COMPANY.brand; };
  }, [title]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <PublicHeader />
      <Container className="py-5 flex-grow-1">
        <Row className="justify-content-center">
          <Col lg={8} className="legal-page">
            <h1 className="h3 mb-1">{title}</h1>
            <p className="text-muted small">Last updated {COMPANY.legalUpdated}</p>
            {intro && <p className="lead fs-6">{intro}</p>}
            {children}
            <hr className="my-4" />
            <nav aria-label="Other legal pages" className="d-flex flex-wrap gap-3 small">
              {PAGES.filter((p) => p.label !== title).map((p) => <Link key={p.to} to={p.to}>{p.label}</Link>)}
              <Link to="/contact">Contact us</Link>
            </nav>
          </Col>
        </Row>
      </Container>
      <PublicFooter />
    </div>
  );
}

/** A numbered section of a legal page. */
export function Section({ title, children }) {
  return (
    <section className="mt-4">
      <h2 className="h6 fw-bold">{title}</h2>
      {children}
    </section>
  );
}

/** The company's contact block, as each legal page ends. */
export function ContactBlock() {
  return (
    <address className="small mb-0">
      {COMPANY.legalName}<br />
      {COMPANY.address}<br />
      Email: <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>
    </address>
  );
}

export default LegalPage;
